import Favicon from 'assets/images/favicon.png';
import Share from 'assets/images/team.jpg';

const title = 'Trampolin';
const description = 'An independent creative studio for a better future, founded and managed by multi-awarded experts for branding, communication, design and technology.';

export const helmet = {
  title,
  titleTemplate: '%s - Trampolin',
  htmlAttributes: { lang: 'en' },
  meta: [
    { name: 'description', content: description },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, user-scalable=no',
    },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
    { name: 'msapplication-navbutton-color', content: '#000' },
    { name: 'msapplication-TileColor', content: '#000' },
    { name: 'theme-color', content: '#000' },

    { property: 'og:title', content: "Welcome to the Trampolin" },
    { property: 'og:image', content: Share },
    { property: 'og:image:width', content: '880px' },
    { property: 'og:image:height', content: '440px' },
    { property: 'og:image:alt', content: description },

    { name: 'twitter:title', content: "Welcome to the Trampolin" },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:image', content: Share },
    { name: 'twitter:description', content: description },
  ],
  link: [{ rel: 'icon', type: 'image/x-icon', href: Favicon }],
};
